export const projectStatusOptions = [
  { label: 'Not Started', value: 'NOT_STARTED' },
  { label: 'Planning', value: 'PLANNING' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Completed', value: 'COMPLETED' },
];

export const projectPriorityOptions = [
  { label: 'Low', value: 'LOW', color: 'gray' },
  { label: 'Medium', value: 'MEDIUM', color: 'yellow' },
  { label: 'High', value: 'HIGH', color: 'orange' },
  { label: 'Critical', value: 'CRITICAL', color: 'red' },
];

export const projectPriorityColors = {
  LOW: 'gray',
  MEDIUM: 'yellow',
  HIGH: 'orange',
  CRITICAL: 'red',
};

export const projectStatusColors = {
  NOT_STARTED: 'default',
  PLANNING: 'blue',
  IN_PROGRESS: 'processing',
  COMPLETED: 'success',
};

export const milestoneStatusOptions = [
  { label: 'Not Started', value: 'NOT_STARTED' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Completed', value: 'COMPLETED' },
];

export const milestoneStatusColors = {
  NOT_STARTED: 'default',
  IN_PROGRESS: 'processing',
  COMPLETED: 'success',
};
